import GroupEventCard from './group-event-card'

export default GroupEventCard
